<section class="container">
    <div class="container text-center">
        <div class="panel panel-default" id="loginDiv" style="display: none; width: 400px; margin: 150px auto;">
            <div class="panel-header">
                <div class="panel-title">
                    <h2>Login</h2>
                </div>
            </div>
            <div class="panel-body">
                <div>
                    <p><input #userId type="text" placeholder="{{bs.getResource('userName')}}"  class="form-control" /></p>
                    <p><input #password type="password" placeholder="{{bs.getResource('password')}}" 
                            (keyup.enter)="validateLogin(userId.value, password.value)" class="form-control"/></p>
                    <p class="submit"><button class="btn btn-info"  (click)="validateLogin(userId.value, password.value)"> Login </button>
                    </p>
                    <div *ngIf="error['err']">
                        <app-error-view [prepareError]="error"></app-error-view>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>

 <footer class="text-center">
	<span>&copy; Copyright 2017 G-Cube. All rights reserved </span>
</footer> 